import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

type CalendarUnit = 'day' | 'week' | 'month'

export const calendarDay = (value: string) => value.slice(0, 10)

export const todayCalendarDay = () => dayjs().format('YYYY-MM-DD')

export const shiftCalendarDate = (value: string, amount: number, unit: CalendarUnit) =>
  dayjs.utc(value).add(amount, unit).format('YYYY-MM-DD')

const calendarMonthStart = (year: number, month: number) =>
  dayjs
    .utc()
    .startOf('year')
    .year(year)
    .month(month - 1)

export const calendarMonthWeeks = (year: number, month: number) => {
  const monthStart = calendarMonthStart(year, month)
  const offset = (monthStart.day() + 6) % 7
  const firstWeekStart = monthStart.subtract(offset, 'day')
  return Array.from({ length: Math.ceil((offset + monthStart.daysInMonth()) / 7) }, (_, week) => {
    const weekStart = firstWeekStart.add(week, 'week')
    return {
      weekStart: weekStart.format('YYYY-MM-DD'),
      days: Array.from({ length: 7 }, (_, weekday) => {
        const date = weekStart.add(weekday, 'day')
        return { date: date.format('YYYY-MM-DD'), inMonth: date.month() === month - 1 }
      }),
    }
  })
}

export const shiftCalendarMonth = (year: number, month: number, amount: number) => {
  const date = calendarMonthStart(year, month).add(amount, 'month')
  return { year: date.year(), month: date.month() + 1 }
}
